module.exports = __webpack_public_path__ + "images/emoji/hearts.4209523e4f2174019de2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hearts.png
// module id = yIGY
// module chunks = 14